import { PipeTransform, Pipe } from "@angular/core";

@Pipe({ name: "time" })
export class TimeStringPipe implements PipeTransform {
  transform(timeString: string): any {
    let stringParts = timeString.match(/.{1,2}/g);
    return `${stringParts[0]}:${stringParts[1]}`;
  }
}
